module.exports = __webpack_public_path__ + "static/media/TasklyVisualDesign.e1d9bf40.png";